module.exports = __webpack_public_path__ + "2d210422486eded7740b7093570dc9b0.svg";